<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="credit-institute-form__form astral-content-width astral-stack-l">
      <section class="astral-section-surface astral-stack-m">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['name']"></astral-input>
          <astral-select [control]="form.controls['cultureName']" [itemsSource]="countries"></astral-select>
          <app-contact-id [control]="form.controls['organizationNumber']" [idType]="idType"></app-contact-id>
        </astral-layout-group>
      </section>
      <section class="astral-section-surface astral-stack-m">
        <app-postal-address [group]="form.controls['postalAddress']" [model]="dataContext.postalAddress" [showName]="true"></app-postal-address>
      </section>
    </form>
  }
</section>
